<div class="backgroud">
  <ng-container *ngIf="showDefaultLayout; else iccrLayout">
    <app-header></app-header>
    <div class="main-content">
      <router-outlet></router-outlet>
      <app-whatsapp class="fixed-icon"></app-whatsapp>
      <app-ai-chat-widget class="fixed-icon"></app-ai-chat-widget>
      <app-footer></app-footer>
    </div>
  </ng-container>

  <ng-template #iccrLayout>
    <app-iccr-header></app-iccr-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </ng-template>
</div>